<template>
  <div>
    <div class="d-flex justify-content-center w-100">
      <div
        v-if="listing.photoUrl"
        class="user-icon-wrapper"
      >
        <img
          class="photo"
          :src="listing.photoUrl"
        >
      </div>
      <div
        v-else
        class="user-icon-wrapper"
      >
        <div class="user-icon text-center">
          <i
            class="far"
            :class="catalogIcon(catalog.productCategory)"
          />
        </div>
      </div>
    </div>

    <div class="listing-name mt-2">
      {{ listing.name }}
    </div>

    <div class="text-center money-font mt-2">
      {{ formatCurrency(listing.price, listing.currency) }}
    </div>
    <hr>

    <div

      v-if="listing.orderFrom || listing.orderTo || listing.cancelTo || listing.countLimit >= 0"
      class="sub-title mt-2"
    >
      {{ $t('shop.availability') }}
    </div>
    <div class="listing-details mt-2">
      <div
        v-if="listing.orderFrom || listing.orderTo || listing.cancelTo || listing.countLimit >= 0"
        class="time-info"
      >
        <div v-if="listing.orderFrom">
          <span class="time-label">{{ $t('shop.orderFrom') }}:</span>
          <span class="time-value">{{ formatDate(listing.orderFrom) }}</span>
        </div>
        <div v-if="listing.orderTo">
          <span class="time-label">{{ $t('shop.orderTo') }}:</span>
          <span class="time-value">{{ formatDate(listing.orderTo) }}</span>
        </div>
        <div v-if="listing.cancelTo">
          <span class="time-label">{{ $t('shop.cancelTo') }}:</span>
          <span class="time-value">{{ formatDate(listing.cancelTo) }}</span>
        </div>
        <div
          v-if="listing.countLimit >= 0"
          class="count-info"
        >
          <span class="time-label">{{ $t('shop.spotsAvailable') }}:</span>
          <span class="time-value">
            {{ Math.max(0, listing.countLimit - listing.countBlocked) }} / {{ listing.countLimit }}
          </span>
        </div>
      </div>
    </div>

    <div class="sub-title mt-2">
      {{ $t('general.description') }}
    </div>
    <div class="mt-2 listing-details">
      {{ listing.description }}
    </div>
    <hr>

    <AvailabilityBottomButton
      :status="status"
      :availability="listing"
      :cancel-to="listing.cancelTo"
      :order-from="listing.orderFrom"
      :order-to="listing.orderTo"
      :count-exceeded="countExceeded"
      @close="handleClose"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import AvailabilityBottomButton from './AvailabilityBottomButton';

export default {
  props: {
    catalog: Object,
    listing: Object,
    payerId: String,
    ordered: Object,
  },
  components: {
    AvailabilityBottomButton,
  },
  computed: {
    ...mapGetters([
      'catalogIcon',
      'formatCurrency',
      'catalogBasket',
    ]),
    status() {
      if (this.ordered) {
        if (this.basketEntry) {
          return 'paidCancelled';
        }
        return 'paid';
      }
      if (this.basketEntry) {
        return 'inBasket';
      }
      return 'available';
    },
    countExceeded() {
      return this.listing.countLimit >= 0
        && this.listing.countBlocked >= this.listing.countLimit;
    },
    basketEntry() {
      return this.catalogBasket
        .find((x) => x.payerId === this.payerId && x.offerId === this.listing.id);
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY HH:mm');
    },
    handleClose() {
      if (this.basketEntry) {
        this.removeFromBasket();
      } else {
        this.addToBasket();
      }
    },
    removeFromBasket() {
      this.$store.commit('removeFromBasket', {
        payerId: this.payerId,
        offerId: this.listing.id,
        isReturned: !!this.ordered,
      });

      this.$emit('close');
    },
    addToBasket() {
      this.$store.commit('addBasketCatalog', {
        payerId: this.payerId,
        price: this.listing.price,
        value: this.listing.price,
        currency: this.listing.currency,
        payeeId: this.catalog.payeeId,
        catalogId: this.catalog.id,
        offerName: this.listing.name,
        offerId: this.listing.id,
        catalog: this.catalog,
        listing: this.listing,
        isReturned: !!this.ordered,
        status: 'inBasket',
      });

      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.listing-name {
  font-weight: 500;
  text-align: center;
}

.photo {
  max-height: 200px;
  max-width: 200px;
}

.sub-title {
  font-size: 16px;
  font-weight: 500;
}

.user-icon {
  color: #aaa;
  font-size: 20px;
  background-color: #D9E9FF;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $blue;
}

.user-icon-wrapper {
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.listing-details {
  font-size: 0.9rem;
  color: #666;
}

.time-info, .count-info {
  text-align: left;
}

.time-value {
  font-weight: 500;
  color: #333;
}

.time-label {
  color: #666;
  margin-right: 5px;
}
</style>
